import { render, staticRenderFns } from "./sessions-grid-tab.vue?vue&type=template&id=e13e13ce&scoped=true&"
import script from "./sessions-grid-tab.vue?vue&type=script&lang=js&"
export * from "./sessions-grid-tab.vue?vue&type=script&lang=js&"
import style0 from "./sessions-grid-tab.vue?vue&type=style&index=0&id=e13e13ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13e13ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VTooltip})
